import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowDown"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0002 21.6213L19.6215 14L17.5002 11.8787L13.5002 15.8787V3H10.5002V15.8787L6.50023 11.8787L4.37891 14L12.0002 21.6213Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowDown;
